import { errorToast, toast } from "@/v2-ui/toast"
import FeatureConfigurationEditor from "@/v2-backoffice-client/feature/configuration/FeatureConfigurationEditor"
import { getBasemapEditorModelPath } from "@/v2-backoffice-client/basemap/update/basemap.update.schema"
import { useBasemapUpdateMutation } from "@/v2-backoffice-client/basemap/update/basemap.update.mutation"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapUpdateEditorProps = {
  className?: string
  basemap: BasemapFragment | null | undefined
}

/**
 * The runtime-catalog binding of the shared configuration editor: saves
 * against the userland gis.Basemaps row, and the normalized cache updates
 * the table and the sheet from the mutation response.
 */
function BasemapUpdateEditor(props: BasemapUpdateEditorProps) {
  const { basemap, className } = props

  const [updateBasemap, { loading, error }] = useBasemapUpdateMutation({
    onCompleted(data) {
      // The thumbnail is re-derived from the saved Configuration, so a save
      // can silently blank the chooser tile. Say so rather than let the
      // operator find out from the console.
      if (!data.updateBasemap.Basemap?.Thumbnail) {
        toast({
          title: "Saved without a thumbnail.",
          description:
            "Properties.thumbnail is empty, so this basemap has no tile in the chooser.",
          variant: "destructive",
        })
      }
    },
  })
  errorToast(error, { title: "Failed to update basemap" })

  if (!basemap) return null

  return (
    <FeatureConfigurationEditor
      className={className}
      modelPath={getBasemapEditorModelPath()}
      value={JSON.stringify(basemap.Configuration, null, 2)}
      isSaving={loading}
      onSave={(configuration) => {
        void updateBasemap({
          variables: {
            input: {
              FeatureCode: basemap.FeatureCode,
              Configuration: configuration,
            },
          },
        })
      }}
    />
  )
}

export default BasemapUpdateEditor
